export default __webpack_public_path__ + "static/media/holiday_bg.dbb7aa60.gif";